import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from './Button';
import { Modal } from './Modal';
import { supportBase } from '../config';

export function GenericErrorModal({ show, onHide }) {
  const { t } = useTranslation();
  return (
    <Modal
      show={show}
      title={t('ERROR.GENERIC_HEADER')}
      onHide={onHide}
      footer={
        <Button onClick={onHide} variant="primary" width="182px">
          Close
        </Button>
      }
    >
      <Trans
        i18nKey="ERROR.GENERIC_DETAIL"
        components={[<a target="_blank" href={supportBase} />]}
      />
    </Modal>
  );
}

GenericErrorModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
